import { render, staticRenderFns } from "./One.vue?vue&type=template&id=3b89b1fb&scoped=true"
import script from "./One.vue?vue&type=script&lang=ts"
export * from "./One.vue?vue&type=script&lang=ts"
import style0 from "./One.vue?vue&type=style&index=0&id=3b89b1fb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b89b1fb",
  null
  
)

export default component.exports